import React from 'react';
import { gql, useQuery } from '@apollo/client';
import ProvinceMapModal from '../components/Map/ProvinceMapModal';

// GraphQL query to fetch sum by province data
const GET_SUM_BY_PROVINCE = gql`
  query GetSumByProvince {
    sumByProvinceOptimized
  }
`;

const ProvinceMapModalContainer = ({ isOpen, onClose }) => {
  const { data, loading, error } = useQuery(GET_SUM_BY_PROVINCE, { skip: !isOpen });
  if (!isOpen) return null;
  const provinceData = (loading || error) ? {} : data?.sumByProvinceOptimized;
  return (
    <ProvinceMapModal
      isOpen={isOpen}
      onClose={onClose}
      data={provinceData}
      loading={loading}
      error={error}
    />
  );
};

export default ProvinceMapModalContainer; 